import { useEffect, useState } from "react";

export default function ShareBar() {
  const [toast, setToast] = useState("");

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(""), 2600);
    return () => clearTimeout(timer);
  }, [toast]);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setToast("链接已复制到剪贴板");
    } catch {
      setToast("复制失败，请手动复制地址栏链接");
    }
  };

  const demo = (label: string) => {
    setToast(`${label}分享为界面演示，暂未接入真实社交平台`);
  };

  const buttons = [
    { icon: "ri-link", label: "复制链接", onClick: copyLink },
    { icon: "ri-wechat-line", label: "微信", onClick: () => demo("微信") },
    { icon: "ri-weibo-line", label: "微博", onClick: () => demo("微博") },
    { icon: "ri-star-line", label: "收藏", onClick: () => demo("收藏") },
  ];

  return (
    <div className="relative">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-foreground-500 mr-1">分享：</span>
        {buttons.map((btn) => (
          <button
            key={btn.label}
            type="button"
            onClick={btn.onClick}
            className="h-9 px-3 rounded-md border border-background-300 text-sm text-foreground-700 flex items-center gap-1.5 hover:bg-background-100 hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className={`${btn.icon} text-base`} />
            {btn.label}
          </button>
        ))}
      </div>
      {toast && (
        <div className="absolute -top-11 left-0 z-20 bg-foreground-950 text-background-50 text-xs px-3 py-2 rounded-md whitespace-nowrap">
          {toast}
        </div>
      )}
    </div>
  );
}